import { AppBar, TitlePortal, UserMenu, useGetIdentity, Logout } from 'react-admin';
import { Box, Typography, Avatar, MenuItem, ListItemIcon, ListItemText, Chip } from '@mui/material';
import { forwardRef } from 'react';
import LogoutIcon from '@mui/icons-material/Logout';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { tokens } from '../theme.js';

const initials = (name) => (name || '')
  .split(' ')
  .filter(Boolean)
  .slice(0, 2)
  .map((s) => s[0]?.toUpperCase())
  .join('') || 'U';

const ROLE_LABEL = {
  super_admin: 'Super admin',
  editor: 'Editor',
};

const VisitSiteItem = forwardRef((props, ref) => (
  <MenuItem
    ref={ref}
    component="a"
    href="/"
    target="_blank"
    rel="noopener noreferrer"
    {...props}
  >
    <ListItemIcon><OpenInNewIcon fontSize="small" /></ListItemIcon>
    <ListItemText>View public site</ListItemText>
  </MenuItem>
));
VisitSiteItem.displayName = 'VisitSiteItem';

const BrandedUserMenu = () => {
  const { identity } = useGetIdentity();
  const name = identity?.fullName || identity?.email || '';

  return (
    <UserMenu
      icon={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          <Box sx={{ textAlign: 'right', display: { xs: 'none', sm: 'block' } }}>
            <Typography variant="body2" sx={{ color: tokens.cream, lineHeight: 1.1, fontWeight: 600 }}>
              {name}
            </Typography>
            <Typography variant="caption" sx={{ color: tokens.goldSoft, fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
              {ROLE_LABEL[identity?.role] || identity?.role || ''}
            </Typography>
          </Box>
          <Avatar
            sx={{
              width: 36, height: 36,
              background: tokens.gold, color: tokens.ink,
              fontSize: 13, fontWeight: 700,
              border: `1.5px solid ${tokens.goldSoft}`,
            }}
          >
            {initials(name)}
          </Avatar>
        </Box>
      }
    >
      <VisitSiteItem />
      <Logout icon={<LogoutIcon fontSize="small" />} />
    </UserMenu>
  );
};

export const MlisAppBar = (props) => (
  <AppBar
    {...props}
    color="primary"
    userMenu={<BrandedUserMenu />}
    sx={{
      background: tokens.green900,
      borderBottom: `2px solid ${tokens.gold}`,
      '& .RaAppBar-toolbar': { paddingInlineEnd: 2 },
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mr: 2 }}>
      <Box
        component="img"
        src="/mlis-logo.jpg"
        alt=""
        sx={{
          width: 32, height: 32,
          borderRadius: '50%',
          border: `1.5px solid ${tokens.gold}`,
        }}
      />
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontFamily: tokens.serif,
            fontWeight: 500,
            fontSize: '1.05rem',
            color: tokens.cream,
            lineHeight: 1.1,
          }}
        >
          Maple Leaf
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: tokens.goldSoft,
            fontSize: 10,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            display: 'block',
          }}
        >
          Content Management
        </Typography>
      </Box>
    </Box>

    <TitlePortal sx={{ flex: 1, color: tokens.cream }} />

    <Chip
      label="Live"
      size="small"
      sx={{
        background: 'rgba(193,154,58,0.18)',
        color: tokens.goldSoft,
        border: `1px solid rgba(193,154,58,0.4)`,
        fontWeight: 700,
        letterSpacing: '0.08em',
        fontSize: 10,
        height: 22,
        mr: 1.5,
        display: { xs: 'none', sm: 'flex' },
      }}
    />
  </AppBar>
);
